<ng-template #content>
  <ng-content
    select=".object-url-content"
    class="text-link"
  ></ng-content>
</ng-template>

@if (!externalLink) {
  @if (!openLinksInTab) {
    <a
      [ngClass]="{'object-url__object-link': !hasImage, 'disable': disable}" class="{{aClass || 'objName-text'}}"
      [routerLink]="!disable ? routerLink : null"
      [queryParams]="queryParams"
      queryParamsHandling="merge"
      (click)="clickItem()"
    >
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
  } @else {
    <a
      [ngClass]="{'object-url__object-link': !hasImage, 'disable': disable}" class="{{aClass || 'objName-text'}}"
      [routerLink]="!disable ? routerLink : null"
      target="_blank"
      rel="noopener noreferrer"
      [queryParams]="queryParams"
      queryParamsHandling="merge"
      (click)="clickItem()"
    >
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
  }
} @else {
  <a
    [ngClass]="{'object-url__object-link': !hasImage,
                'disable': disable}"
    class="{{aClass || 'objName-text'}}"
    (click)="clickExternalItem(externalLink)"
    appExternalUrl
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
}

